import { render } from "./Service-Section.vue?vue&type=template&id=7f2b2636&scoped=true"
import script from "./Service-Section.vue?vue&type=script&lang=js"
export * from "./Service-Section.vue?vue&type=script&lang=js"

import "./Service-Section.vue?vue&type=style&index=0&id=7f2b2636&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2b2636"]])

export default __exports__